import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminBadge',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TooltipProvider), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
        default: _withCtx(() => [
          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Badge), {
                variant: "secondary",
                class: "px-1.5 py-0 text-xs font-semibold leading-tight cursor-help",
                "aria-label": _ctx.$t('layouts.dashboard.sideBar.badges.admin')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('layouts.dashboard.sideBar.badges.admin')), 1)
                ]),
                _: 1
              }, 8, ["aria-label"])
            ]),
            _: 1
          }),
          _createVNode(_unref(TooltipContent), { class: "max-w-[14rem] text-sm font-normal leading-snug" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('layouts.dashboard.sideBar.badges.adminTooltip')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})